import styled from 'styled-components';

// COLORS
import { theme } from '../../constants/theme';

export const ModalTextMessage = styled.div`
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.regular};
  font-size: 12px;
  line-height: 16px;
  color: ${theme.colors.secondary.gray300};

  width: 384px;

  display: flex;
  flex-direction: column;
  padding-top: 4vh;

  textArea {
    margin: 1vh 0 1vh 0;
    padding: 10px;
    border: 1px solid ${theme.colors.secondary.gray500};
    border-radius: 8px;
    min-height: 120px;
    color: ${theme.colors.secondary.gray200};
    outline: 0;
    font-size: 14px;
    line-height: 24px;
  }
`;
